import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Link } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  media1: {
    maxWidth: 773,
    maxHeight: 1364,
    width: '100%',
    marginTop: '4vh',
    boxShadow: "0px 0px 6px 1px #b7b7b7"
  },
  media2: {
    maxWidth: 773,
    maxHeight: 1212,
    width: '100%',
    marginTop: '4vh',
    boxShadow: "0px 0px 6px 1px #b7b7b7",
  },
  content: {
    alignItems: 'center'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '0%' }}
      >
        <Grid item style={{ paddingTop: '5vh', display: 'contents' }}>
          <Link
            href="/images/projects/screen-swagger-autogen-small.png"
            target="_blank"
          >
            <img alt="asdf" className={classes.media1} src="/images/projects/screen-swagger-autogen-small.png" />
          </Link>
          <Link
            href="/images/projects/screen-swagger-autogen-cut.png"
            target="_blank"
          >
            <img alt="asdf" className={classes.media2} src="/images/projects/screen-swagger-autogen-cut.png" />
          </Link>
        </Grid>
      </Grid>
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '3vh' }} />
    </div>
  );
};

export default Header;